exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".duration-box[data-v-ce4e8dfc]{margin-bottom:-70px;margin-right:10px;margin-top:10px;z-index:2;position:relative;background-color:#000;opacity:0.6}.eye-gray-color[data-v-ce4e8dfc]{color:#bfbfbf}.video-title[data-v-ce4e8dfc]{line-height:1.6}\n", ""]);

